// Resolves the first accessible route for a user based on their accesslevel.
// Used after login to redirect to the correct initial screen.

const KNOWN_PLATFORMS = ['acesso', 'mobility']
const mobility_ROUTES    = ['parking', 'users', 'campanhas']

export async function resolveFirstRoute(userId: number): Promise<string> {
  try {
    // @ts-ignore
    const { useStrapi } = await import('#imports')
    // @ts-ignore
    const { useStrapiUser } = await import('#imports')

    const strapi = useStrapi()
    const user   = useStrapiUser()

    const accessId = user.value?.accesslevel?.id
    if (!accessId) return '/dashboard'

    const res  = await strapi.findOne('accesslevels', accessId)
    const list = res?.data?.attributes?.route
    if (!list || typeof list !== 'object') return '/dashboard'

    // 1. Primeira plataforma conhecida com pelo menos uma rota
    for (const platform of KNOWN_PLATFORMS) {
      const routes = list[platform]
      if (!Array.isArray(routes) || routes.length === 0) continue

      // Primeira rota da plataforma (pode ser dashboard ou outra)
      const first = routes.find((r: any) => !mobility_ROUTES.includes(typeof r === 'string' ? r : r.to))
      if (!first) continue

      const to = typeof first === 'string' ? first : first.to
      if (to === 'dashboard') return `/dashboard?id=${platform}`
      return `/${to}?id=${platform}`
    }

    // 2. mobility — usa dashboard do mobility
    if (Array.isArray(list.mobility) && list.mobility.length > 0) {
      const first = list.mobility[0]
      const to = typeof first === 'string' ? first : first.to
      if (to === 'dashboard') return `/dashboard?id=mobility`
      return `/${to}`
    }

    // 3. Definições (admin)
    if (Array.isArray(list.settings) && list.settings.length > 0) {
      const first = list.settings[0]
      const tab = typeof first === 'string' ? first : first.to
      return `/admin?tab=${tab}`
    }

    // 4. Fallback
    return '/dashboard'
  } catch (e) {
    console.warn('[resolveFirstRoute] error:', e)
    return '/dashboard'
  }
}
